import {
  Dropzone,
  FileMosaic,
  FullScreen,
  ImagePreview,
  VideoPreview,
} from "@files-ui/react";
import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  uploadAuditReport,
  processAuditReport,
  uploadCapProof,
} from "../../reducers/audit.reducer";
import {
  selectFilesUploadedIds,
  selectFileUploadStatus,
} from "../../selectors/misc.selector";
import Snackbar from "@mui/material/Snackbar";
import {
  setFilesUploadedIds,
  setFileUploadStatus,
} from "../../reducers/misc.reducer";
import { useParams } from "react-router-dom";
import { selectSelectedAuditIssueId } from "../../selectors/audit.selector";
import {
  selectOrganisationId,
  selectSupplierId,
} from "../../selectors/login.selector";
import { uploadFile } from "../../reducers/collaborativeForm.reducer";
import UploadStatusPopup from "../Common/UploadStatusPopup";

const BASE_URL = "https://www.myserver.com";

const AuditDocumentDrop = ({
  factoryId,
  onClose,
  mode = "upload",
  label = null,
  auditId = "none",
  emails = null,
  issueId = null,
  uploadContext = {},
}) => {
  const organisationId = useSelector(selectOrganisationId);
  const supplierId = useSelector(selectSupplierId);
  const [extFiles, setExtFiles] = React.useState([]);
  const [imageSrc, setImageSrc] = React.useState(undefined);
  const [videoSrc, setVideoSrc] = React.useState(undefined);
  const [open, setOpen] = React.useState(false);
  const [message, setMessage] = React.useState("");
  const dispatch = useDispatch();
  const params = useParams();
  const filesUploadedIds = useSelector(selectFilesUploadedIds);
  const fileUploadStatus = useSelector(selectFileUploadStatus);
  console.log("fileUploadStatus", fileUploadStatus);
  const [showStatusPopup, setShowStatusPopup] = React.useState(false);

  React.useEffect(() => {
    if (Object.keys(filesUploadedIds).length > 0) {
      let successfulIds = Object.keys(filesUploadedIds).filter(
        (x) => filesUploadedIds[x] === true
      );
      setMessage(
        `${successfulIds.length} ${
          successfulIds.length > 1 ? "files" : "file"
        } uploaded successfully, ${
          successfulIds.length > 1 ? "they have" : "it has"
        } been removed from the dropbox.`
      );
      setOpen(true);
      setExtFiles(extFiles.filter((x) => !filesUploadedIds[x.id]));
      dispatch(setFilesUploadedIds({}));
    }
  }, [filesUploadedIds]);

  React.useEffect(() => {
    if (fileUploadStatus === 1 || fileUploadStatus === 2) {
      setShowStatusPopup(true);
    }
    if (fileUploadStatus === 2) {
      setTimeout(() => {
        onClose();
        dispatch(setFileUploadStatus(0));
        setShowStatusPopup(false);
      }, 1000);
    }
  }, [fileUploadStatus, onClose, dispatch]);

  const updateFiles = (incommingFiles) => {
    console.log("incomming files", incommingFiles);
    setExtFiles(incommingFiles);
  };

  const onDelete = (id) => {
    setExtFiles(extFiles.filter((x) => x.id !== id));
  };

  const handleSee = (imageSource) => {
    setImageSrc(imageSource);
  };

  const handleWatch = (videoSource) => {
    setVideoSrc(videoSource);
  };
  const selectedIssueId = useSelector(selectSelectedAuditIssueId);
  const handleStart = (filesToUpload) => {
    console.log(`Starting file upload process with mode: ${mode}`);
    console.log(`Files to upload:`, filesToUpload);

    if (mode === "traceability_form") {
      dispatch(
        uploadFile(
          {
            formId: uploadContext.formId,
            uniqueKey: uploadContext.uniqueKey,
            file: filesToUpload,
            uploadContext: uploadContext,
            fileType: uploadContext.type,
          },
          {
            file: filesToUpload,
          }
        )
      );
    } else if (mode === "upload") {
      console.log("Dispatching uploadAuditReport action");
      dispatch(
        uploadAuditReport(
          {
            auditId: params.auditId,
            issueId: selectedIssueId,
            file: filesToUpload,
            type: label ? "capClosed" : null,
          },
          { file: filesToUpload }
        )
      );
    } else if (mode === "capProof") {
      console.log("Dispatching uploadCapProof action");
      dispatch(
        uploadCapProof(
          {
            auditId: auditId,
            issueId: issueId,
            file: filesToUpload,
            type: "capClosed",
          },
          { file: filesToUpload }
        )
      );
    } else if (mode === "process") {
      console.log("Dispatching processAuditReport action");
      dispatch(
        processAuditReport(
          {
            organisationId,
            supplierId,
            factoryId,
            auditId: "none",
            file: filesToUpload,
            emails,
          },
          { file: filesToUpload }
        )
      );
    }

    console.log("Closing the modal after starting the upload");
    onClose(); // Close the modal after starting the upload
  };

  const handleFinish = (uploadedFiles) => {
    console.log("advanced demo finish upload", uploadedFiles);
  };

  const handleAbort = (id) => {
    setExtFiles(
      extFiles.map((ef) => {
        if (ef.id === id) {
          return { ...ef, uploadStatus: "aborted" };
        } else return { ...ef };
      })
    );
  };

  const handleCancel = (id) => {
    setExtFiles(
      extFiles.map((ef) => {
        if (ef.id === id) {
          return { ...ef, uploadStatus: undefined };
        } else return { ...ef };
      })
    );
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  const handleCloseStatusPopup = () => {
    setShowStatusPopup(false);
    if (fileUploadStatus === 2) {
      dispatch(setFileUploadStatus(0));
    }
  };

  return (
    <>
      <Dropzone
        onChange={updateFiles}
        minHeight="400px"
        value={extFiles}
        label={label || "Drag'n drop files here or click to browse"}
        onUploadStart={handleStart}
        onUploadFinish={handleFinish}
        actionButtons={{
          position: "after",
          abortButton: {},
          deleteButton: {},
          uploadButton: {
            onClick: () => {
              handleStart(extFiles);
            },
          },
        }}
      >
        {extFiles.map((file) => (
          <FileMosaic
            {...file}
            key={file.id}
            onDelete={onDelete}
            onSee={handleSee}
            onWatch={handleWatch}
            onAbort={handleAbort}
            onCancel={handleCancel}
            resultOnTooltip
            alwaysActive
            preview
            info
          />
        ))}
      </Dropzone>
      <FullScreen
        open={imageSrc !== undefined}
        onClose={() => setImageSrc(undefined)}
      >
        <ImagePreview src={imageSrc} />
      </FullScreen>
      <FullScreen
        open={videoSrc !== undefined}
        onClose={() => setVideoSrc(undefined)}
      >
        <VideoPreview src={videoSrc} autoPlay controls />
      </FullScreen>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        message={message}
      />
      <UploadStatusPopup
        open={showStatusPopup}
        status={fileUploadStatus}
        onCloseStatusPopup={handleCloseStatusPopup}
        onClose={onClose}
      />
    </>
  );
};

export default AuditDocumentDrop;